export default Object.freeze({
  ZRSI: 'SINIESTRO',
  ZRMA: 'PREVENTIVO',
  ZRMC: 'CORRECTIVO',
});
